import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoGooglePlus = () => {
  return (
    <g>
      <path d="M5.09 3a4.93 4.93 0 0 1 3.412 1.307L7.12 5.614a2.895 2.895 0 0 0-2.03-.771c-1.752.03-3.157 1.434-3.157 3.156 0 1.72 1.405 3.125 3.158 3.155 1.378.095 2.613-.828 2.887-2.156H5.091V7.284h4.807c.052.273.08.55.08.828a4.562 4.562 0 0 1-1.337 3.509 4.743 4.743 0 0 1-3.55 1.375C2.279 12.996 0 10.758 0 7.998 0 5.238 2.28 3 5.09 3zm9.455 2.857v1.427H16v1.428h-1.455v1.427h-1.454V8.712h-1.455V7.284h1.455V5.857h1.454z" />
    </g>
  );
};

export default withIcon(IconLogoGooglePlus);
